const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M26.0161%2016.1631V30.2453L40.0002%2016.1631H26.0161Z'%20fill='%23F7931F'/%3e%3cpath%20d='M26.016%2016.1633V10H0V30.2456L13.9718%2016.1633H26.016Z'%20fill='%232E3590'/%3e%3cpath%20d='M13.9718%2016.1631L0%2030.2453H26.016V16.1631H13.9718Z'%20fill='%2341B4E7'/%3e%3c/svg%3e";
export {
  e as default
};
